import fetch from '../../utils/fetch';
import { API_ROUTES } from '../../utils/constants';

export const requestClientTokenAPI = () => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const formData = new FormData();
  formData.append('grant_type', 'client_credentials');
  return fetch({
    method: 'POST', route: API_ROUTES.LOGIN, requestHeaders: headers, data: formData, basic: true,
  });
};

export const loginAPI = (data) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  const formData = new FormData();
  formData.append('grant_type', 'password');
  formData.append('username', data.username);
  formData.append('password', data.password);
  return fetch({
    method: 'POST', route: API_ROUTES.LOGIN, requestHeaders: headers, data: formData, basic: true,
  });
};

export const refreshTokenAPI = (data) => {
  const formData = new FormData();
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  formData.append('grant_type', 'refresh_token');
  formData.append('refresh_token', data);

  return fetch({
    method: 'POST', route: API_ROUTES.LOGIN, requestHeaders: headers, data: formData, basic: true,
  });
};

export const logoutAPI = (data) => {
  const formData = new FormData();
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  formData.append('grant_type', 'refresh_token');
  formData.append('access_token', data);

  return fetch({
    method: 'POST', route: API_ROUTES.LOGOUT, requestHeaders: headers, data: formData, basic: true,
  });
};




// WEBPACK FOOTER //
// ./src/reducers/oauth/api.js